import React, { useState, useEffect } from 'react';
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Search } from 'lucide-react';

interface ArtistCount {
  name: string;
  count: number;
}

interface ArtistFacetProps {
  artists: ArtistCount[];
  selectedArtists: string[];
  onArtistChange: (artist: string) => void;
}

export function ArtistFacet({
  artists,
  selectedArtists,
  onArtistChange
}: ArtistFacetProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredArtists, setFilteredArtists] = useState(artists);

  useEffect(() => {
    if (searchQuery) {
      setFilteredArtists(
        artists.filter(artist => 
          artist.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    } else {
      setFilteredArtists(artists);
    }
  }, [searchQuery, artists]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Search is handled by useEffect
  };

  return (
    <Card className="p-4">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Label className="text-base font-medium">Artist</Label>
        </div>
        
        <form onSubmit={handleSearch} className="flex gap-2">
          <Input
            placeholder="Search artists..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1"
          />
          <Button type="submit" size="sm" variant="outline">
            <Search className="h-4 w-4" />
          </Button>
        </form>

        <div className="space-y-2 max-h-48 overflow-y-auto">
          {filteredArtists.map(artist => (
            <div key={artist.name} className="flex items-center space-x-2">
              <Checkbox
                id={`artist-${artist.name}`}
                checked={selectedArtists.includes(artist.name)}
                onCheckedChange={() => onArtistChange(artist.name)}
              />
              <Label htmlFor={`artist-${artist.name}`} className="text-sm flex-1">
                {artist.name} ({artist.count})
              </Label>
            </div>
          ))}
          {filteredArtists.length === 0 && (
            <div className="text-sm text-muted-foreground text-center py-2">
              No artists found
            </div>
          )}
        </div>
      </div>
    </Card>
  );
} 